import { Dispatch, SetStateAction } from 'react';
import { Modal } from '@phoenix/design-system/frontend/ui/modal/modal';
import { Button } from '@phoenix/design-system/frontend/ui/button/button';
import { useTranslation } from 'next-i18next';
import { useConnectedUserInfo } from '../hooks/use-connected-user-info.hook';

export const ConnectedUserInfoModal = ({
  presentConnectedUserInfoModal,
  setPresentConnectedUserInfoModal,
  setDoNotShowConnectedUserInfoModalAgain,
  doNotShowConnectedUserInfoModalAgain,
}: {
  presentConnectedUserInfoModal: boolean;
  setPresentConnectedUserInfoModal: Dispatch<SetStateAction<boolean>>;
  setDoNotShowConnectedUserInfoModalAgain: Dispatch<SetStateAction<boolean>>;
  doNotShowConnectedUserInfoModalAgain: boolean;
}) => {
  const { t } = useTranslation(['shared']);
  useConnectedUserInfo({ doNotShowConnectedUserInfoModalAgain });

  const handleConnectedUserInfoModalCloseModal = () => {
    setPresentConnectedUserInfoModal(false);
  };

  return (
    <Modal
      dialogIsOpen={presentConnectedUserInfoModal}
      closeDialog={handleConnectedUserInfoModalCloseModal}
      ariaLabelName="connected_user_info_modal"
    >
      <h3 className="stihl-text-h3-mobile">{t('shared_dealers_overlay_connectedUser_headline')}</h3>
      <div className="mt-6 whitespace-pre-line stihl-text-body-default-reg">{t('shared_dealers_overlay_connectedUser_copy')}</div>
      <div className="mt-xl flex flex-col gap-4 sm:flex-row">
        <Button
          type="button"
          btnType="white_default"
          onClick={handleConnectedUserInfoModalCloseModal}
          className="w-full sm:w-auto"
          data-testid="connected_user_info_modal-button-dismiss"
        >
          {t('shared_dealers_overlay_connectedUser_button_okay')}
        </Button>
        <Button
          type="button"
          btnType="white_outline"
          onClick={() => {
            setDoNotShowConnectedUserInfoModalAgain(true);
            handleConnectedUserInfoModalCloseModal();
          }}
          className="w-full sm:w-auto"
          data-testid="connected_user_info_modal-button-dont-remind-me-again"
        >
          {t('shared_dealers_overlay_connectedUser_checkbox_dontRemind')}
        </Button>
      </div>
    </Modal>
  );
};
